import { render, staticRenderFns } from "./Indicador.vue?vue&type=template&id=4a4634c8&scoped=true"
import script from "./Indicador.vue?vue&type=script&lang=js"
export * from "./Indicador.vue?vue&type=script&lang=js"
import style0 from "./Indicador.vue?vue&type=style&index=0&id=4a4634c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4634c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
